import React, { useEffect, useState } from "react";
import TextButton from "../../Button/TextButton/TextButton";
import styled from "styled-components";
import Text from "../../Text/Text";
import Spacer from "../../Spacer/Spacer";
import SelectInput from "../../Input/SelectInput/SelectInput";
const StyledUnbindVehicleScreen = styled.div `
  height: calc(100% - 40px);
  width: calc(100% - 100px);
  margin: 20px 50px;
`;
const StyledButtonContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 100%;
`;
const StyledInputWrapper = styled.div `
  height: calc(100% - 30px);
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const UnbindVehicleScreen = (props) => {
    const { vehicles, handleUnbindVehicle, } = props;
    useEffect(() => {
        setVehicle(vehicles[0]);
    }, [vehicles]);
    const [vehicle, setVehicle] = useState(vehicles[0]);
    const vehicleOptions = vehicles.map(vehicle => vehicle.name);
    const handleClick = () => {
        if (!!vehicle) {
            handleUnbindVehicle(vehicle);
        }
    };
    const handleVehicleChange = (value) => {
        const vehicle = vehicles.find(vehicle => vehicle.name === value);
        setVehicle(vehicle);
    };
    return (React.createElement(StyledUnbindVehicleScreen, null,
        React.createElement(StyledInputWrapper, null,
            React.createElement(Text, { text: "Select Vehicle" }),
            React.createElement(Spacer, { height: 5 }),
            React.createElement(SelectInput, { options: vehicleOptions, initialValue: vehicleOptions[0], handleChange: handleVehicleChange }),
            React.createElement(Spacer, { height: 36 })),
        React.createElement(StyledButtonContainer, null,
            React.createElement(TextButton, { text: "Unlink", color: "#FFFFFF", backgroundColor: "#3F51B5", borderRadius: 5, borderWidth: 0, handleClick: handleClick }))));
};
export default UnbindVehicleScreen;
